import { motion } from "framer-motion";
import { Church, GlassWater, Shirt, Car, Clock } from "lucide-react";
import { ChapterTag, Reveal } from "./shared";

const ICONS = [Church, GlassWater, Shirt, Car, Clock];

export default function Chapter3Details({ config }) {
  return (
    <section className="relative bg-warm-white py-28 md:py-40" data-testid="chapter-3">
      <div className="mx-auto max-w-6xl px-6 md:px-16">
        <ChapterTag n={2} title="Detalles de la boda" />
        <Reveal>
          <h2 className="mb-16 max-w-2xl font-serif text-4xl font-light leading-tight tracking-tight text-deep-black md:text-6xl">
            Todo lo que necesitas <span className="italic text-gold-soft">saber</span>.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {config.details.map((d, i) => {
            const Icon = ICONS[i % ICONS.length];
            const span = i === 0 ? "lg:col-span-2" : "";
            const Wrapper = d.link ? motion.a : motion.div;
            const linkProps = d.link
              ? { href: d.link, target: "_blank", rel: "noopener noreferrer" }
              : {};
            return (
              <Wrapper
                key={i}
                {...linkProps}
                data-testid={`detail-card-${i}`}
                data-cursor="hover"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: (i % 3) * 0.08 }}
                whileHover={{ y: -8 }}
                className={`group relative block overflow-hidden rounded-2xl border border-deep-black/10 bg-ivory p-8 shadow-[0_10px_40px_-20px_rgba(10,10,10,0.25)] ${span}`}
              >
                <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-gold/10 blur-2xl transition-opacity duration-500 group-hover:opacity-100 opacity-0" />
                <Icon className="mb-8 h-6 w-6 text-gold-soft" strokeWidth={1.2} />
                <div className="flex items-baseline justify-between">
                  <h3 className="font-serif text-3xl font-light text-deep-black">{d.title}</h3>
                  <span className="text-xs uppercase tracking-[0.2em] text-gold-soft">{d.time}</span>
                </div>
                <p className="mt-1 text-sm font-light text-deep-black/50">{d.place}</p>
                <div className="max-h-0 overflow-hidden opacity-0 transition-all duration-500 group-hover:mt-4 group-hover:max-h-24 group-hover:opacity-100">
                  <p className="text-sm font-light leading-relaxed text-deep-black/70">{d.text}</p>
                </div>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}
